import React from 'react'
import PropTypes from 'prop-types'

import { AppStore, PlayStore } from '../../buttons/StoreButtons'

import './StoreIcons.scss'

const StoreIcons = ({
  storeLink, showAppStore, showPlayStore, useTargetSelf
}) => {
  const target = useTargetSelf ? '_self' : '_blank'
  return (
    <div className="store-icons">
      {
        showAppStore
        && (
          <div className="store-icons__icon">
            <AppStore href={storeLink} height={40} target={target} />
          </div>
        )
      }
      {
        showPlayStore
        && (
          <div className="store-icons__icon">
            <PlayStore href={storeLink} height={40} target={target} />
          </div>
        )
      }
    </div>
  )
}


StoreIcons.defaultProps = {
  showAppStore: true,
  showPlayStore: true,
  useTargetSelf: true
}

StoreIcons.propTypes = {
  showAppStore: PropTypes.bool,
  showPlayStore: PropTypes.bool,
  storeLink: PropTypes.string.isRequired,
  useTargetSelf: PropTypes.bool
}


export default StoreIcons
